import React from "react"
// react component for creating dynamic tables
import ReactTable from "react-table"

import * as Alert from "alertService"
import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer"
import { ErrorsCallback, SuccessCallback } from "alertService"
import { thaiBath } from "helpers/ConvertFormat"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsCallInTypeUpdate , listsCallInTypeSub1Update } from "store/actions"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import EventNoteIcons from "@material-ui/icons/EventNote"
import {arrayObject} from "ConvertKey"
// import Dvr from "@material-ui/icons/Dvr";
// import Favorite from "@material-ui/icons/Favorite";
import DeleteForeverIcons from "@material-ui/icons/DeleteForever"
// core components
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import Switch from "@material-ui/core/Switch"
import Badge from "components/Badge/Badge"
import Tooltip from "@material-ui/core/Tooltip";
import FormLabel from "@material-ui/core/FormLabel"

import { cardTitle } from "assets/jss/material-dashboard-pro-react"

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle"
import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle";
const styles = {
  ...extendedFormsStyle,
  ...tasksStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  noConfirmedemail: {
    color: "red"
  },
  devType: {
    color: "#689F38"
  },
  tableH: {
    // marginTop: "30px",
    // marginBottom: "30px"
  }
}
class ProjectListManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pageName:"การโทรเข้า-หัวข้อ",
      statusWaitingUpdate: true,
      callInTypeListRaw: [],
      callInTypeList: [],
      callInTypeCurrentID: "",
      dataListRaw: [],
      dataList: []
    }
  }
  componentDidMount() {
    // Alert.Loading()
    // this.props.listsCallInTypeUpdate(true)
  }
  
  componentWillUpdate(nextProps, nextState) {
    // if (this.state.statusWaitingUpdate) {
    if (nextProps.listsCallInType !== nextState.callInTypeListRaw) {
      var dataList = this.renderListData(nextProps.listsCallInType)
      const newConvertDatas = arrayObject(nextProps.listsCallInType,[
        {
          oldKey:"_id",
          newKey:"value"
        },
        {
          oldKey:"description",
          newKey:"name"
        }
      ])
      if(newConvertDatas.length < 1)return
      this.setState({
        statusWaitingUpdate: false,
        callInTypeList: newConvertDatas,
        callInTypeListRaw: nextProps.listsCallInType,
        // callInTypeCurrentID:newConvertDatas[0].value
      },()=>{
        Alert.LoadingClose()
        // this.props.listsCallInTypeSub1Update(this.state.callInTypeCurrentID,true)
      })
    }
    if (nextProps.listsCallInTypeSub1 !== nextState.dataListRaw) {
      var dataList = this.renderListData(nextProps.listsCallInTypeSub1)
      this.setState({
        statusWaitingUpdate: false,
        dataListRaw: nextProps.listsCallInTypeSub1,
        dataList: dataList
      },()=>{
        Alert.LoadingClose()
        this.props.callbacksetTabIndex(0)
      })
    }
    if(nextProps.callInTypeCurrentID !== nextState.callInTypeCurrentID && nextProps.callInTypeCurrentID !== undefined && nextProps.callInTypeCurrentID !== ""){
      this.setState({
        callInTypeCurrentID:nextProps.callInTypeCurrentID
      },()=>{})
    }
  }
  loadListsCallInTypeSub1 = () => {
    this.props.listsCallInTypeSub1Update(this.state.callInTypeCurrentID)
  }
  handleUserViewDetail = (indexData)=>{
    this.props.callbacksetTabIndex(1)
    this.props.callbackSetCurrentData(this.state.dataListRaw[indexData])
  }

  renderListData = data => {
    return data.map((CData, key) => {
      return {
        id: (key + 1),
        description: CData.description,
        // userType:(
        //   <div className={this.props.classes.tableH}>
        //     <Badge color={"info"}>{dataUser.user_type_name}</Badge>
        //   </div>),
        active: (
          <div>
            <Tooltip
                id="tooltip-top"
                title={ ((CData.active)?"ปิด":"เปิด") + " การใช้งานข้อรหัสนี้" }
                placement="top"
                classes={{ tooltip: this.props.classes.tooltip }}
              >
              <Switch
                checked={CData.active}
                onChange={e => {
                  this.handleChangeActive(CData._id, CData.description ,!CData.active)
                }}
                classes={{
                  switchBase: this.props.switchBase,
                  checked: this.props.switchChecked,
                  icon: this.props.switchIcon,
                  iconChecked: this.props.switchIconChecked,
                  bar: this.props.switchBar
                }}
              />
            </Tooltip>
          </div>
        ),
        actions: (
          <div className="actions-right">
            <Button
              // disabled={dataUser.user_type_code === 0 ? true : false}
              // justIcon
              round
              onClick={() => this.handleUserViewDetail(key)
              }
              color="info"
              className="remove"
            >
              <Tooltip
                id="tooltip-top"
                title="แสดงรายละเอียด / สามารถแก้ไขข้อมูลได้"
                placement="top"
                classes={{ tooltip: this.props.classes.tooltip }}
              >
                <div><EventNoteIcons /> ดู / แก้ไข</div>
              </Tooltip>
            </Button>{" "}
            <Button
              justIcon
              round
              onClick={() =>
                this.handleDeleteData(CData._id,CData.description)
              }
              color="danger"
              className="remove"
            >
              <Tooltip
                id="tooltip-top"
                title="ลบข้อมูลนี้"
                placement="top"
                classes={{ tooltip: this.props.classes.tooltip }}
              >
                <DeleteForeverIcons />
              </Tooltip>
            </Button>{" "}
          </div>
        )
      }
    })
  }
  handleChangeState = name => event => {
    const val = event.target.value
    this.setState({
      [name]: val
    },()=>{
      if( name === "callInTypeCurrentID"){
        this.loadListsCallInTypeSub1(val)
      }
    })
  }
  handleChangeActive = (id,name, status) => {
    Alert.QuestionCallback("คุณต้องการเปลี่ยนสถานะการใช้งานของ " + name + " เป็น "+ status +" ใช่หรือไม่?","blue",()=>{
      const dataToSend = {
        substatusId:id,
        active:status
      }
      APIPost( UrlServer.URL_POST_ACTIVE_CALL_IN_TYPE_SUB_1,dataToSend,(datas)=>{
          this.props.listsCallInTypeSub1Update(this.state.callInTypeCurrentID,true)
      })
    })
  }
  handleDeleteData = (id,  name) => {
    Alert.QuestionCallback("คุณต้องการลบ " + name + " ใช่หรือไม่?","red",()=>{
      const dataToSend = {
        substatusId:id,
      }
      APIPost( UrlServer.URL_POST_DELETE_CALL_IN_TYPE_SUB_1,dataToSend,(datas)=>{
        SuccessCallback(datas.message,null,()=>{
          this.props.listsCallInTypeSub1Update(this.state.callInTypeCurrentID,true)
        })
      })
    })
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card >
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <FormatListNumberedIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>รายการ {this.state.pageName}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  {/* <GridItem xs={12} sm={12} md={3} lg={3}>
                    <FormLabel className={classes.labelHorizontal}>
                    รายการหัวข้อหลัก
                    </FormLabel>
                  </GridItem> */}
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    {
                      (this.state.callInTypeList.length > 0) ?
                        <Select
                          label={"รายการสถานะหลัก"}
                          value={this.state.callInTypeCurrentID}
                          listData={this.state.callInTypeList}
                          onChange={this.handleChangeState("callInTypeCurrentID")}
                        />
                        : ""
                    }
                  </GridItem>
                </GridContainer>
                <hr className={classes.marginHR} />
                <span>จำนวน {thaiBath(this.state.dataList.length,false)} รายการ</span> 
                <ReactTable
                  data={this.state.dataList}
                  filterable
                  columns={[
                    {
                      Header: "No.",
                      accessor: "id"
                    },
                    {
                      Header: "ชื่อสถานะย่อย",
                      accessor: "description"
                    },
                    {
                      Header: "สถานะเปิดใช้งาน",
                      accessor: "active",
                      filterable: false
                    },
                    {
                      Header: "ตั้งค่าต่างๆ",
                      accessor: "actions",
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight"
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

function mapStateToProps({ listsCallInType,listsCallInTypeSub1 }) {
  return {
    listsCallInType: listsCallInType,
    listsCallInTypeSub1: listsCallInTypeSub1
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { 
      listsCallInTypeUpdate,
      listsCallInTypeSub1Update
    }
  )
)(ProjectListManagement)
